module.exports = __webpack_public_path__ + "static/media/3-7.6a8fa8fd.webp";